/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'ai-mate.chat-error-banner.description': 'Seu histórico de bate-papo é salvo por até 30 dias.',
  'ai-mate.chat-error-banner.title': 'Iniciar novo bate-papo',
  'ai-mate.chat-error.description': 'Tente <btn>recarregar o bate-papo</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Você atingiu o número máximo de solicitações. Tente de novo mais tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Muitas solicitações',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que o Rovo não está habilitado no site. <link>Configurar o Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'O Rovo está inativo',
  'ai-mate.chat-error.title': 'A gente não sabe o que deu errado',
  'ai-mate.main-chat.close-chat-button-label': 'Fechar',
  'ai-mate.main-chat.maximize-chat-button-label': 'Tela cheia',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restaurar visualização',
  'ai-mate.main-chat.new-chat-button-label': 'Novo',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Novo bate-papo',
  'conversation-assistant-button.label': 'Bate-papo',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pergunte ao Atlassian Intelligence sobre isso',
  'highlight-actions.rovo-chat-explain-option.text': 'Explique',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explique isso parafraseando e incluindo mais informações, mas utilizando uma linguagem bem simples, frases curtas e dando exemplos e definições para qualquer terminologia técnica utilizada na frase original.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Procurar recursos',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Descubra recursos apenas com conhecimentos organizacionais que corroborem com a declaração feita.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Dê exemplos',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Dê exemplos disto em recursos organizacionais ou conhecimento público. Se não houver recursos para oferecer, tente fazer uma metáfora para exemplificar e ajudar alguém a entender melhor.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar feedback',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Dê feedback analisando a formulação disto. Faça comentários sobre a escolha de palavras, a gramática e a pontuação. Seja positivo e empolgado, mas sempre aponte pelo menos uma coisa que precisa ser melhorada ou alterada.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendações de bate-papo',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir bate-papo',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Destaque os principais pontos disto. Foque em informações essenciais e descarte dados desnecessários. Ofereça uma visão geral concisa em um único parágrafo.',
  'highlight-actions.rovo-chat.button-text': 'Bate-papo',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Pergunte no chat',
  'horizontal-scroll-container.scroll-left': 'Rolar para a esquerda',
  'horizontal-scroll-container.scroll-right': 'Rolar para a direita',
};
